/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useCallback } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, IconButton, Tooltip } from '@mui/material';
import { InputInteger } from '../InputInteger';
import "./styles.css";
import { CSSProperties } from '@mui/styles';
import { notifierStore } from 'src/framework/components/commons/dialogs/Notifier/store';

export interface InputQuantidadeParameters {
    value: number,
    minValue?: number,
    maxValue?: number,
    multiple?: number,
    label?: string,
    onChange: Function,
    disabled?: boolean,
    checkMultiple?: boolean
    disableRipple?: boolean,
    hasError?: boolean
    customStyle?: CSSProperties,
    size?: 'small' | 'medium' | undefined,
    disableMenos?: boolean,
    avulso?: boolean,
}

const InputQuantidade: FC<InputQuantidadeParameters> = ({
  value = "0",
  label = "",
  disabled = false,
  disableRipple = false,
  onChange = () => null,
  size = "small",
  customStyle = {},
  minValue = 0,
  maxValue = 1,
  multiple = 1,
  checkMultiple = false,
  disableMenos = false,
  hasError = false,
  avulso,
}) => {
    const onClickMais = useCallback(
        (e: any) => onChange(e + multiple),
        [onChange, multiple],
    );

    const onClickMenos = useCallback(
        (e: any) => {
            const newValue = e - multiple;
            onChange(newValue > minValue ? newValue : minValue);
        },
        [onChange, multiple],
    );

    const checkError = useCallback((qtd: number): boolean => {
        if (!multiple) {
            return false;
        }
        if (qtd === 0) {
            return false;
        }
        if (qtd % multiple === 0) {
            return false;
        }
        return true
    }, []);

    const handleChange = (e: any)=>{
        if (checkMultiple && checkError(e)){
            notifierStore.setNotifier({
                title: "Aviso!",
                content: `A quantidade deve ser múltipla de ${multiple}.`,
                onClose: () => {
                    onChange(e)
                },
                noTimeOut: true,
            })
            notifierStore.open();
        } else if (Number(e) > maxValue){
            notifierStore.setNotifier({
                title: "Aviso!",
                content: `Não é possível adicionar mais que ${maxValue} unidade(s) do ${avulso ? 'item' : 'kit'} escolhido.`,
                onClose: () => {
                    onChange(value)
                },
                noTimeOut: true,
            })
            notifierStore.open();
        } else if ((!avulso && Number(e) < minValue) || (Number(e) === 0 && minValue > 0)) {
            notifierStore.setNotifier({
                title: "Aviso!",
                content: `Não é possível adicionar menos que ${minValue} unidade(s) do ${avulso ? 'item' : 'kit'} escolhido.`,
                onClose: () => {
                    onChange(value)
                },
                noTimeOut: true,
            })
            notifierStore.open();
        } else {
            onChange(e)
        }
    }

    return (
        <Tooltip title={Number(value) > 0 ? "" : "Adicione pelo menos um item."}>
            <Box className="root" style={customStyle as React.CSSProperties}>
                <IconButton 
                    size={size}
                    className="remove" 
                    disabled={disabled || disableMenos || Number(value) <= minValue}
                    disableRipple={disableRipple}
                    onClick={() => onClickMenos(Number(value))}
                >
                    <RemoveIcon fontSize={size}/>
                </IconButton>
                
                <InputInteger
                    label={label}
                    value={value}
                    type="number"
                    className="input"
                    hasError={hasError}
                    disabled={disabled}
                    onChangeValue={(_name: string, value: any) => handleChange(value)}
                />

                <IconButton 
                    size={size}
                    className="add" 
                    disabled={disabled || Number(value) >= maxValue} 
                    disableRipple={disableRipple}
                    onClick={() => onClickMais(Number(value))}
                >
                    <AddIcon fontSize={size}/>
                </IconButton>
            </Box>
        </Tooltip>
    )
};

export default InputQuantidade;